export default {
    POST_RECEIVED: 'POST_RECEIVED',
    POST_REMOVED: 'POST_REMOVED',
    POST_SHARED: 'POST_SHARED',
    POST_SCHEDULED: 'POST_SCHEDULED',
    POST_UNSCHEDULED: 'POST_UNSCHEDULED',
    POST_REMOVED_IMAGE: 'POST_REMOVED_IMAGE',
};
